export enum ContractLinkModalTab {
  CreatedByMe = 'created-by-me',
  AllContracts = 'all-contracts',
}
